exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".container___3-lQ3 {\n  background-color: #00aeef;\n  min-height: 100vh;\n  padding: 95px 15px 0;\n  line-height: 1.5;\n  text-align: center;\n}\n.title___903LN {\n  font-size: 35px;\n  color: #fff;\n  margin-top: 10px;\n}\n.content___38r95 {\n  font-size: 24px;\n  margin-top: 15px;\n}\n.read___169WB {\n  color: #333;\n  background-color: #fff;\n  line-height: 45px;\n  width: 100px;\n  border-radius: 12px;\n  font-size: 17px;\n  display: inline-block;\n  margin-top: 20px;\n}\n.img_404___2IRlo {\n  width: 100%;\n}", ""]);

// exports
exports.locals = {
	"container": "container___3-lQ3",
	"title": "title___903LN",
	"content": "content___38r95",
	"read": "read___169WB",
	"img_404": "img_404___2IRlo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/views/error-page/404.css
// module id = 478
// module chunks = 0